import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CustomerWorkOrdersTab from './CustomerModalTabs/CustomerWorkOrdersTab'
import CustomerInfosTab from './CustomerModalTabs/CustomerInfosTab'
import { connect } from 'react-redux';
import { compose } from 'redux'
import CustomerAffairsTab from './CustomerModalTabs/CustomerAffairsTab';
import CustomerQuotesTab from './CustomerModalTabs/CustomerQuotesTab';

const styles = {
    appBar: {
        position: 'relative',
        marginBottom: '10px',
    },
    flex: {
        flex: 1,
    },
};

function TabContainer({ children, dir }) {
    return (
        <Typography component="div" dir={dir}>
            {children}
        </Typography>
    );
}

class CustomerModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedTab: 0,
        }
        this.modalContainer = React.createRef();
    }

    handleChange = (event, value) => {
        this.setState({ selectedTab: value });
        this.modalContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };

    handleChangeIndex = index => {
        this.setState({ selectedTab: index });
        this.modalContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };

    close() {
        this.props.onClose();
    }

    render() {
        const { classes } = this.props;

        if (!this.props.customerSearch || !this.props.modalOpenned)
            return null;

        return (
            <div>
                <Dialog aria-labelledby="simple-dialog-title" open={this.props.modalOpenned}
                    onClose={this.close.bind(this)} fullScreen>
                    <DialogContent className="without-side-padding">
                        <div ref={node => {
                            this.modalContainer = node;
                        }}>

                            <AppBar className={classes.appBar}>
                                <Toolbar>
                                    <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography variant="h6" color="inherit" className={classes.flex}>
                                        Client
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <AppBar position="static" color="default">
                                <Tabs value={this.state.selectedTab} onChange={this.handleChange.bind(this)}
                                    indicatorColor="primary" textColor="primary" variant="fullWidth" >
                                    <Tab label="Identité" />
                                    <Tab label="Interventions" />
                                    <Tab label="Devis" />
                                    <Tab label="Affaire" />
                                </Tabs>
                            </AppBar>
                            <DialogContent className="without-padding">
                                <SwipeableViews axis='x' index={this.state.selectedTab} onChangeIndex={this.handleChangeIndex.bind(this)} >
                                    <TabContainer>
                                        <CustomerInfosTab customer={this.props.customerSearch} />
                                    </TabContainer>
                                    <TabContainer className="col-lg-12 col-md-12 col-sm-12 col-12">
                                        <CustomerWorkOrdersTab workOrders={this.props.customerSearch.work_order_ids} />
                                    </TabContainer>
                                    <TabContainer className="col-lg-12 col-md-12 col-sm-12 col-12">
                                        <CustomerQuotesTab quotes={this.props.customerSearch.quotes_ids} />
                                    </TabContainer>
                                    <TabContainer className="col-lg-12 col-md-12 col-sm-12 col-12">
                                        <CustomerAffairsTab affairs={this.props.customerSearch.affair_ids} />
                                    </TabContainer>
                                </SwipeableViews>
                            </DialogContent>
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        customerSearch: state.tiers.customerSearch,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(CustomerModal);
